'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var menuItemActive = exports.menuItemActive = function menuItemActive() {
  var FinalPathLocation = window.location.pathname.replace(/\/$/, '');
  FinalPathLocation = FinalPathLocation.replace(/\/$/, ''); // remove last slash from url
  switch (FinalPathLocation) {
    case '/collections/fall-winter-20-21':
      FinalPathLocation = "/collections/best-sellers-1";
      break;
  }
  var SpanArray = document.querySelectorAll('.data-nav-item');
  SpanArray.forEach(function (element) {
    var ChildUrlLink = '';
    if (element.tagName.toLowerCase() === "li") {
      ChildUrlLink = Array.from(element.children).find(function (child) {
        return child.tagName.toLowerCase() === "a";
      });
      ChildUrlLink = ChildUrlLink.getAttribute('href').replace(/\/$/, '');
    }
    if (element.tagName.toLowerCase() === "span") {
      ChildUrlLink = element.parentElement.getAttribute('href').replace(/\/$/, '');
    }
    if (FinalPathLocation === ChildUrlLink && FinalPathLocation != '') {
      element.closest(" .windows-menu--dropdown").classList.add("menu-item-active");
      element.classList.add("menu-item-active");
      element.parentElement.classList.add("menu-item-active");
    }
  });
};